import PropTypes from 'prop-types';
import withPermissions from '../utils/with-affiliate-config';

const HasPermissions = (props) => {
  const {
    permissions,
    config,
    hasPermissions,
    hasConfigEnabled,
    children,
    or,
  } = props;

  if (permissions && hasPermissions(permissions)) {
    return children;
  }

  if (config && hasConfigEnabled(config)) {
    return children;
  }

  return or ? or() : null;
};

HasPermissions.propTypes = {
  hasPermissions: PropTypes.func,
  hasConfigEnabled: PropTypes.func,
  permissions: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  config: PropTypes.string,
  children: PropTypes.node,
  or: PropTypes.func,
};

export default withPermissions(HasPermissions);



// WEBPACK FOOTER //
// ./src/components/HasPermissions.js